import React from 'react';
import { Download, Share, SquarePlus, X } from 'lucide-react';

export const InstallCard = ({ ios, canPrompt, onInstall, onDismiss }) => (
  <div className="install-card" data-testid="install-card">
    <img src="/icon-192.png" alt="" className="install-icon" />
    <div className="install-text">
      <div className="install-title">Install Vibely</div>
      {ios ? (
        <ol className="install-steps" data-testid="install-ios-steps">
          <li>Tap <Share size={14} /> <strong>Share</strong> in Safari</li>
          <li>Choose <SquarePlus size={14} /> <strong>Add to Home Screen</strong></li>
        </ol>
      ) : (
        <div className="install-sub">Full-screen app with alerts that reach you even when it is closed.</div>
      )}
      {ios && <div className="install-sub">Then open Vibely from your home screen and turn on alerts there. Needs iOS 16.4 or newer.</div>}
    </div>
    <div className="install-actions">
      {!ios && canPrompt && (
        <button type="button" className="alerts-enable" onClick={onInstall} data-testid="install-button">
          <Download size={14} /> Install
        </button>
      )}
      <button type="button" className="alerts-dismiss" onClick={onDismiss} aria-label="Not now" data-testid="dismiss-install-button"><X size={16} /></button>
    </div>
  </div>
);
